var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadplaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 92,
    viewBox: "0 0 241 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9208 12.1042L85.048 13.4163C72.8221 16.7126 69.2623 22.9269 72.5576 35.1233L75.8529 47.3198C78.6801 57.8537 83.7064 61.9834 92.8526 60.7928C94.3192 60.6257 95.8984 60.3076 97.5903 59.8386L102.492 58.4961C114.658 55.1724 118.248 48.9865 114.953 36.7901L111.656 24.5642C110.984 22.0842 110.205 19.9316 109.263 18.1672C105.582 11.1657 99.6656 9.45074 89.9208 12.1042Z",
    fill: "url(#paint0_linear_623_3620)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9208 12.1042L85.048 13.4163C72.8221 16.7126 69.2623 22.9269 72.5576 35.1233L75.8529 47.3198C78.6801 57.8537 83.7064 61.9834 92.8526 60.7928C94.3192 60.6257 95.8984 60.3076 97.5903 59.8386L102.492 58.4961C114.658 55.1724 118.248 48.9865 114.953 36.7901L111.656 24.5642C110.984 22.0842 110.205 19.9316 109.263 18.1672C105.582 11.1657 99.6656 9.45074 89.9208 12.1042Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.143 55.0656C155.818 55.2228 155.88 56.1076 155.222 56.327L151.337 57.6057C141.574 60.7533 136.435 58.1221 133.263 48.3596L130.115 38.6463C126.968 28.8838 129.574 23.7198 139.337 20.5722L140.625 20.1455C141.616 19.8174 142.58 20.811 142.299 21.8159C142.159 22.3141 142.025 22.8339 141.894 23.3755L139.484 33.679C136.779 45.2612 140.738 51.6548 152.321 54.4089L155.143 55.0656Z",
    fill: "url(#paint1_linear_623_3620)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.143 55.0656C155.818 55.2228 155.88 56.1076 155.222 56.327L151.337 57.6057C141.574 60.7533 136.435 58.1221 133.263 48.3596L130.115 38.6463C126.968 28.8838 129.574 23.7198 139.337 20.5722L140.625 20.1455C141.616 19.8174 142.58 20.811 142.299 21.8159C142.159 22.3141 142.025 22.8339 141.894 23.3755L139.484 33.679C136.779 45.2612 140.738 51.6548 152.321 54.4089L155.143 55.0656Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.083 12.9246L166.19 13.8837C176.493 16.2935 179.641 21.3838 177.231 31.6627L174.821 41.9416C172.756 50.8188 168.674 54.409 161.001 53.6713C159.772 53.573 158.444 53.3517 157.018 53.0074L152.886 52.0238C142.632 49.5893 139.46 44.5236 141.87 34.2447L144.28 23.9412C144.772 21.851 145.362 20.0313 146.099 18.5313C148.977 12.5803 153.87 10.982 162.083 12.9246Z",
    fill: "url(#paint2_linear_623_3620)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.083 12.9246L166.19 13.8837C176.493 16.2935 179.641 21.3838 177.231 31.6627L174.821 41.9416C172.756 50.8188 168.674 54.409 161.001 53.6713C159.772 53.573 158.444 53.3517 157.018 53.0074L152.886 52.0238C142.632 49.5893 139.46 44.5236 141.87 34.2447L144.28 23.9412C144.772 21.851 145.362 20.0313 146.099 18.5313C148.977 12.5803 153.87 10.982 162.083 12.9246Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.033 32.9082L213.906 34.2202C226.132 37.5165 229.692 43.7309 226.396 55.9273L223.101 68.1237C220.274 78.6576 215.248 82.7874 206.101 81.5967C204.635 81.4296 203.056 81.1116 201.364 80.6425L196.462 79.3001C184.296 75.9763 180.706 69.7904 184.001 57.594L187.298 45.3682C187.97 42.8881 188.749 40.7355 189.691 38.9712C193.372 31.9696 199.288 30.2547 209.033 32.9082Z",
    fill: "url(#paint3_linear_623_3620)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.033 32.9082L213.906 34.2202C226.132 37.5165 229.692 43.7309 226.396 55.9273L223.101 68.1237C220.274 78.6576 215.248 82.7874 206.101 81.5967C204.635 81.4296 203.056 81.1116 201.364 80.6425L196.462 79.3001C184.296 75.9763 180.706 69.7904 184.001 57.594L187.298 45.3682C187.97 42.8881 188.749 40.7355 189.691 38.9712C193.372 31.9696 199.288 30.2547 209.033 32.9082Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9669 22.5062L27.094 23.8183C14.8682 27.1146 11.3083 33.3289 14.6036 45.5253L17.899 57.7217C20.7262 68.2556 25.7525 72.3854 34.8987 71.1947C36.3652 71.0277 37.9445 70.7096 39.6364 70.2405L44.5377 68.8981C56.7037 65.5744 60.294 59.3885 56.9987 47.192L53.7024 34.9662C53.0302 32.4861 52.2512 30.3335 51.3086 28.5692C47.6285 21.5677 41.7117 19.8527 31.9669 22.5062Z",
    fill: "url(#paint4_linear_623_3620)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9669 22.5062L27.094 23.8183C14.8682 27.1146 11.3083 33.3289 14.6036 45.5253L17.899 57.7217C20.7262 68.2556 25.7525 72.3854 34.8987 71.1947C36.3652 71.0277 37.9445 70.7096 39.6364 70.2405L44.5377 68.8981C56.7037 65.5744 60.294 59.3885 56.9987 47.192L53.7024 34.9662C53.0302 32.4861 52.2512 30.3335 51.3086 28.5692C47.6285 21.5677 41.7117 19.8527 31.9669 22.5062Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3620",
    x1: 87.2595,
    y1: 7.45104,
    x2: 84.8708,
    y2: 75.4655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3620",
    x1: 134.694,
    y1: 19.3181,
    x2: 170.202,
    y2: 47.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_3620",
    x1: 148.684,
    y1: 12.1413,
    x2: 186.932,
    y2: 50.1247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_3620",
    x1: 211.694,
    y1: 28.255,
    x2: 214.083,
    y2: 96.2695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_623_3620",
    x1: 29.3055,
    y1: 17.853,
    x2: 26.9169,
    y2: 85.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadplaceholder);
export default __webpack_public_path__ + "static/media/uploadplaceholder.1ea873a4f8aa0adf6422cff2b83fda4f.svg";
export { ForwardRef as ReactComponent };